import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const EmailTooltipText = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="EmailTooltipText">
      {t('stylistScreen.addStylist.emailTooltip.descriptionPart1')}
      <br />
      {t('stylistScreen.addStylist.emailTooltip.descriptionPart2')}
      <br />
      {t('stylistScreen.addStylist.emailTooltip.descriptionPart3')}
    </div>
  );
};

export default EmailTooltipText;
